module.exports = __webpack_public_path__ + "assets/img/returnBtn-65812195.png";